import { cn } from "../../../lib/utils";
import { protocolColor } from "../utils/gatewayUtils";

export default function GatewayProtocolBadge({
  protocol,
  className,
}: {
  protocol: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-1.5 py-px rounded text-[10px] font-semibold border leading-4",
        protocolColor(protocol),
        className
      )}
    >
      {protocol}
    </span>
  );
}
